import { getStringBytes } from '@/scripts/tools/utils';

const validate = {
  getTagsErrorMsg(tags) {
    let result = '';
    const reg = /^(项目|project|qcs:)/;

    const pluck = (objs, str) => {
      let res = [];
      res = objs.map(item => item[str]);
      return res;
    };

    tags.forEach(obj => {
      if (!obj.Key || !obj.Value) {
        result = '请填写完整标签键和标签值';
        return false;
      }
      if (reg.test(obj.Key.toLowerCase())) {
        result = '标签键不能以 项目、project、qcs: 开头';
        return false;
      }
      if (getStringBytes(obj.Key) > 127) {
        result = '标签键长度不能大于 127 字符';
        return false;
      }
      if (getStringBytes(obj.Value) > 255) {
        result = '标签值长度不能大于 255 字符';
        return false;
      }
      return true;
    });

    if (Array.from(new Set(pluck(tags, 'Key'))).length < pluck(tags, 'Key').length) {
      result = '标签键不允许重复';
    }
    return result;
  },
};

export default validate;
